import { create } from "zustand";


interface IPermitIsCanceledModalStore {
    isModalOpen: boolean;
    closeModal: () => void;
    openModal: () => void;
}

export const permitIsCanceledModalStore = create<IPermitIsCanceledModalStore>((set) => ({
    isModalOpen: false,
    closeModal: () => set((state) => ({
        ...state,
        isModalOpen: false,
    })),
    openModal: () => set((state) => ({
        ...state,
        isModalOpen: true,
    })),
}));

export const useIsOpenCancelPermitModalData = () => {
    return permitIsCanceledModalStore((state) => state.isModalOpen);
}

export const useCloseCancelPermitModalData = () => {
    return permitIsCanceledModalStore((state) => state.closeModal);
}

export const useOpenCancelPermitModalData = () => {
    return permitIsCanceledModalStore((state) => state.openModal);
}